import { ReactNode, ButtonHTMLAttributes } from 'react';

interface SecondaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  icon?: ReactNode;
}

export const SecondaryButton = ({ children, icon, className = '', ...props }: SecondaryButtonProps) => {
  return (
    <button
      className={`flex items-center justify-center gap-2 rounded-xl border-2 border-primary bg-white px-6 py-3 text-base font-bold text-primary shadow-lg transition-colors hover:bg-primary hover:text-white disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      {...props}
    >
      {icon && <span>{icon}</span>}
      <span>{children}</span>
    </button>
  );
};
